<template>
  <div class="search-icon">
    <img class="favicon" :src="favicon" />
    <div class="icon"
         :style="colors[event]">
           <component :is="statusIcons[event]"
                      width="10"
                      height="10" />
    </div>
  </div>
</template>

<script>
  import { extractHostname } from '@/services/utils'

  export default {
    props: {
      link: {
        type: String,
        required: true
      },
      event: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        favicon: '',
        statusIcons: {
          'warn': 'IconExclamationSign',
          'block': 'IconBlock'
        },
        colors: {
          'warn': 'background: #f7c716',
          'block': 'background: #ea1643'
        }
      }
    },
    created() {
      this.favicon = `https://plus.google.com/_/favicon?domain=${ extractHostname(this.link) }`
    }
  }
</script>

<style lang='scss' scoped>
  .search-icon {
    position: relative;
    margin: 0 16px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid #e5e5e5;

    .favicon {
      width: 16px;
      height: 16px;
      margin: 7px;
      border-radius: 50%;
    }

    .icon, .custom-icon {
      color: #fff;
      position: absolute;
      bottom: -2px;
      right: -2px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 16px;
      height: 16px;
      box-shadow: 0 2px 4px 0 rgba(#000, .1);
      border-radius: 50%;
    }
  }
</style>
